import React, {Component} from 'react';
import {  push } from 'gatsby';
import PropTypes from 'prop-types';
import encode from '../utils/'
import Layout from '../components/layout';
import Banner from '../components/banner';
import Bullets from '../components/bullet';
import Aboutus from '../components/about';
import Services from '../components/services';
import Contact from '../components/contact';
import Why from '../components/why';

class IndexPage extends Component {
  constructor(props){
    super(props);
    this.state = {
      form: {},
    };
  }
  handleChange = (e) => {
    const { form } = this.state;
    this.setState({
      form: { ...form, ...{ [e.target.name]: e.target.value } },
    });
  }

  handleSubmit = (e) => {
    const { form } = this.state;
    fetch('/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: encode({ 'form-name': 'appointment', ...form }),
    })
      .then(() => push('/success'))
      .catch(error => window.console.log(error));

    window.console.log('Form data', form);
    e.preventDefault();
  }

  render() {
return (
    <Layout>
      <Banner />
              <Bullets />
              <Aboutus />
              <Services />
              <Why />
              <Contact />
    </Layout>);
  }
  };
IndexPage.propTypes = {
  data: PropTypes.shape(PropTypes.object),
};
IndexPage.defaultProps = {
  data: {},
};
export default IndexPage;
